module.exports = __webpack_public_path__ + "static/media/Nodes.8a7521a9.svg";